(function() {
  var $cartPopupId = $('#ph-cart_popup'),
      addToCartLoader = '.ph-addtocart-loader',
      addToCartButtonClass = '.addtocartButton',
      addToCartAnimation = '.ph-addtocart_animation',
      videoIconSection = '.ph-video-icons-section';

  ACC.product = {

    bindAll: function() {
      ACC.product.bindToAddToCartForm();
      ACC.product.bindToAddToFavForm();
      $('#carousel_modal').jcarousel({
      // Configuration goes here
        vertical: null,
        itemFallbackDimension: 512
      });

      $('.noaction').click(function(e) {
        e.preventDefault();
      });
    },
    addTocartFormValidation: function($addToCartForm) {
      $addToCartForm.validate({
        rules: {
          qty: {
            required: true,
            min: 1,
            digits: true
          }
        }
      });
    },
    addToCartSubmission: function($addToCartForm) {
      $.ajax({
        type: 'POST',
        url: ACC.config.contextPath + $addToCartForm.attr('action'),
        dataType: 'json',
        data: $addToCartForm.serialize(),
        success: function(cartResult, statusText, xhr) {
          $('.ph-loader__default').hide();
          ACC.product.addToCartLoaderToCheckIcon($addToCartForm);
          ACC.product.displayAddToCartPopup(cartResult, statusText, xhr, $addToCartForm);
        }
      });
    },
    addToCartLoaderToCheckIcon: function($addToCartForm) {
      $($addToCartForm).children(addToCartAnimation).children(addToCartButtonClass).children(addToCartLoader).addClass('hidden');
      $($addToCartForm).find('.ph-addtocart-checkmark').removeClass('hidden');
    },
    addToCartIconToLoaderIcon: function($addToCartForm) {
      $('#addToCartForm button, .ph-addtocart').addClass('disabled');
      $($addToCartForm).children(addToCartAnimation).children(addToCartButtonClass).addClass('ph-addtocart-pointers');
      $($addToCartForm).children(addToCartAnimation).children(addToCartButtonClass).removeClass('disabled');
      $($addToCartForm).children(addToCartAnimation).children(addToCartButtonClass).children(addToCartLoader).removeClass('hidden');
      $($addToCartForm).children(addToCartAnimation).children(addToCartButtonClass).removeClass('ph-icon-refreshcart');
      $($addToCartForm).children(addToCartAnimation).children(addToCartButtonClass).removeClass('ph-icon-shoppingcart');
    },
    bindToAddToCartForm: function() {
      $(document).ready(function() {
        if ($(document).find('.template-pages-layout-landingLayout1Page').length === 0) {
          $(document).find('.add_to_cart_form').each(function() {
            ACC.product.addTocartFormValidation($(this));
          });
        }

        $(document).on('submit', '.add_to_cart_form', function(e) {
          ACC.product.addToCartIconToLoaderIcon($(this));
          ACC.product.addToCartSubmission($(this));

          e.preventDefault();

          return false;
        });

        $(document).on('click', '.ph-sparepart_ack_pdp', function(e) {
          var formObj = $(this).parent();

          if ($('.ph-product-isSpProduct')[0].value === 'true' && ACC.product.checkForSpInCart()) {
            e.preventDefault();
            ACC.quickOrder.changeAcknowledgePopup(formObj);
          }
        });

        $(window).resize(function() {
          if ($('.rollover_cart_popup').length > 0) {
            ACC.product.placingAddtocartPopup();
          }
        });
        $(document).on('click', 'body,html', function(e) {
          $(document).find('.ph-add2cart-formload').removeClass('ph-add2cart-formload');

          if ($(e.target).closest($cartPopupId).length === 0 && $(e.target).closest('.ph-addtocartform').length === 0) {
            ACC.product.closeCartPopup();
          }
        });
      });
    },
    placingAddtocartPopup: function() {
      var windowWidth = parseInt($(window).width(), 10);

      $cartPopupId.removeAttr('style');

      if (windowWidth > 961) {
        var addToCartRightOffset = windowWidth - ($('#minicart_data').offset().left + $('#minicart_data').outerWidth());

        $cartPopupId.css('right', parseInt(addToCartRightOffset, 10) + 'px');
      }
    },
    commonAnimation: function(formElement) {
      $('#addToCartForm button, .ph-addtocart').removeClass('disabled');
      $(formElement).find('.ph-addtocartcategory').addClass('ph-icon-refreshcart');
      $(formElement).find('.ph-addtocart-checkmark').addClass('hidden');
      $(formElement).find('.addtocartButton').removeClass('ph-addtocart-pointers');
    },
    closeCartPopup: function(formElement) {
      $cartPopupId.hide();
      ACC.product.commonAnimation(formElement);
      $(formElement).children('.ph-addtocart_animation').children(addToCartButtonClass).children(addToCartLoader).addClass('hidden');
    },

    /* eslint-disable max-statements */
    displayAddToCartPopup: function(cartResult, statusText, xhr, formElement) {
      /* eslint-enable max-statements */
      var productCode = $('[name=productCodePost]', formElement).val(),
          quantityField = $('[name=qty]', formElement).val(),
          quantity = 1;

      if ($('.rollover_cart_popup').length > 0) {
        ACC.product.placingAddtocartPopup();
      }

      if ($('.page-cartPage').length > 0 && !cartResult.cartError) {
        location.reload(true);
      }

      /* eslint-disable  no-undefined */
      if (quantityField !== undefined) {
      /* eslint-enable  no-undefined */
        quantity = quantityField;
      }

      ACC.product.trackAddToCart(productCode, quantity, cartResult.cartData);

      $('.fav_popup').hide();
      $cartPopupId.html(cartResult.cartPopupHtml).hide();

      if (cartResult.cartError) {
        $('.ph-generalerror').show().find('.ph-info_negative').removeClass('hidden');
        $('.ph-generalerror').find('.ph-product_show_generalerror').html(cartResult.cartError);
        $('html, body').animate({
          scrollTop: 0
        }, 'slow');
      } else {
        $cartPopupId.fadeIn();
        ACC.imgLazyLoad.setImageObserver();
      }

      $('#add_to_cart_close').click(function(e) {
        e.preventDefault();
        ACC.product.closeCartPopup(formElement);
      });

      if (typeof ACC.refreshMiniCart.refreshMiniCart === 'function') {
        ACC.refreshMiniCart.refreshMiniCart();
      }

      setTimeout(function() {
        ACC.product.closeCartPopup(formElement);
      }, 5000);

      $.colorbox.close();
    },

    bindToAddToFavForm: function() {
      var $addToFavForm = $('.add_to_fav_form');

      $addToFavForm.ajaxForm({
        success: ACC.product.displayAddToFavPopup
      });
    },

    displayAddToFavPopup: function(cartResult) {
      $cartPopupId.hide();
      $('.fav_popup').hide();
      $('.fav_popup').html(cartResult.cartPopupHtml);

      $('.add_to_fav_close').click(function(e) {
        e.preventDefault();
        $('.fav_popup').hide();
      });


      $('.fav_popup').fadeIn();

      setTimeout(function() {
        $('.fav_popup').fadeOut();
      }, 5000);

      $.colorbox.close();
    },

    trackAddToCart: function(productCode, quantity, cartData) {
      window.mediator.publish('trackAddToCart', {
        productCode: productCode,
        quantity: quantity,
        cartData: cartData
      });

      var omnitureDescription = 'addtocart:productcode:' + productCode;

      ACC.omniture.bindTrackConversion('add_to_cart', omnitureDescription);
    },

    zoomImage: function() {
    // Jcarousel().jcarouse() is a workaround for a jcarousel bug.
      $('#carousel_modal').jcarousel({
        vertical: null
      }).jcarousel({
        vertical: null,
        itemFallbackDimension: 512
      });

      $('.noaction').click(function(e) {
        e.preventDefault();
      });
    },

    connector: function(itemNavigation, carouselStage) {
      return carouselStage.jcarousel('items').eq(itemNavigation.index());
    },

    productCarousalImage: function() {
    // Setup the carousels. Adjust the options for both carousels here.
      var carouselStage = $('.ph-product__carouselStage').jcarousel();
      var carouselNavigation = $('.ph-product__carouselNavigation').jcarousel();

      /* We loop through the items of the navigation carousel and set it up
       as a control for an item from the stage carousel. */

      $('.ph-product__carousel')
        .on('jcarousel:create jcarousel:reload', function() {
          var $element = $(this),
              width = $element.innerWidth();

          $element.jcarousel('items').css('width', Math.ceil(width) + 'px');
        }).jcarousel({
          wrap: null
        }).jcarouselSwipe({
          perSwipe: 1
        });

      $('.ph-product__carouselNavigation')
        .on('jcarousel:create jcarousel:reload', function() {
          var $element = $(this),
              width = $element.innerWidth(),
              windowWidth = $(window).width();

          if (width >= 300 && windowWidth >= 640) {
            width = width / 3;
          } else {
            width = width / 2;
          }

          $element.jcarousel('items').css('width', Math.ceil(width - 6) + 'px');
        }).jcarousel({
          wrap: null
        });


      carouselNavigation.jcarousel('items').each(function() {
        var $item = $(this);

        // This is where we actually connect to items.
        var target = ACC.product.connector($item, carouselStage);

        $item
          .on('jcarouselcontrol:active', function() {
            carouselNavigation.jcarousel('scrollIntoView', this);
            $item.addClass('active');
          })
          .on('jcarouselcontrol:inactive', function() {
            $item.removeClass('active');
          })
          .jcarouselControl({
            target: target,
            carousel: carouselStage
          });
      });

      // Setup controls for the stage carousel
      $('.ph-prev-stage')
        .on('jcarouselcontrol:inactive', function() {
          $(this).addClass('inactive');
        })
        .on('jcarouselcontrol:active', function() {
          $(this).removeClass('inactive');
        })
        .jcarouselControl({
          target: '-=1'
        });

      $('.ph-next-stage')
        .on('jcarouselcontrol:inactive', function() {
          $(this).addClass('inactive');
        })
        .on('jcarouselcontrol:active', function() {
          $(this).removeClass('inactive');
        })
        .jcarouselControl({
          target: '+=1'
        });

      // Setup controls for the navigation carousel
      $('.ph-prev-navigation')
        .on('jcarouselcontrol:inactive', function() {
          $(this).addClass('inactive');
        })
        .on('jcarouselcontrol:active', function() {
          $(this).removeClass('inactive');
        })
        .jcarouselControl({
          target: '-=1'
        });

      $('.ph-next-navigation')
        .on('jcarouselcontrol:inactive', function() {
          $(this).addClass('inactive');
        })
        .on('jcarouselcontrol:active', function() {
          $(this).removeClass('inactive');
        })
        .jcarouselControl({
          target: '+=1'
        });

      $('.jcarousel-pagination')
        .on('jcarouselpagination:active', 'a', function() {
          $(this).addClass('active');
        })
        .on('jcarouselpagination:inactive', 'a', function() {
          $(this).removeClass('active');
        })
        .on('click', function(e) {
          e.preventDefault();
        })
        .jcarouselPagination({
          item: function(page) {
            return '<a href="#' + page + '">' + page + '</a>';
          }
        });
    },

    carouselVideo: function() {
      var carouselStageVideo = $('.ph-product__image').jcarousel();
      var carouselNavigationVideo = $('.ph-product__Video').jcarousel();

      carouselNavigationVideo.jcarousel('items').each(function() {
        var $item = $(this);

        var target = ACC.product.connector($item, carouselStageVideo);

        $item
          .on('jcarouselcontrol:active', function() {
            carouselNavigationVideo.jcarousel('scrollIntoView', this);
            $item.addClass('active');
          })
          .on('jcarouselcontrol:inactive', function() {
            $item.removeClass('active');
          })
          .jcarouselControl({
            target: target,
            carousel: carouselStageVideo
          });
      });
    },

    playpause: function(currentVideo) {
      if (currentVideo[0].paused || currentVideo[0].ended) {
        $(currentVideo[0]).parents('.ph-video').find('.ph-product__playIconDetailImage').addClass('ph-icon-pause').removeClass('ph-icon-play-button');
        currentVideo[0].play();
      } else {
        $(currentVideo[0]).parents('.ph-video').find('.ph-product__playIconDetailImage').removeClass('ph-icon-pause').addClass('ph-icon-play-button');
        currentVideo[0].pause();
      }
    },

    updatebar: function(pagex, currentVideo) {
      var progress = $(currentVideo[0]).parents('.ph-video').find('.ph-video__progress');

      /* Calculate drag position
         and update video currenttime
         as well as progress bar */
      var maxduration = currentVideo[0].duration,
          position = pagex - progress.offset().left,
          percentage = 100 * position / progress.width();

      if (percentage > 100) {
        percentage = 100;
      }

      if (percentage < 0) {
        percentage = 0;
      }

      $(currentVideo[0]).parents('.ph-video').find('.ph-video__timebar').css('width', percentage + '%');
      currentVideo[0].currentTime = maxduration * percentage / 100;
    },

    timeFormat: function(seconds) {
      var minutes = Math.floor(seconds / 60),
          sec = 0;

      if (Math.floor(seconds - (minutes * 60)) < 10) {
        sec = '0' + Math.floor(seconds - (minutes * 60));
      } else {
        sec = Math.floor(seconds - (minutes * 60));
      }

      if (Math.floor(seconds / 60) < 10) {
        minutes = '0' + Math.floor(seconds / 60);
      } else {
        minutes = Math.floor(seconds / 60);
      }

      return minutes + ':' + sec;
    },

    updateVolume: function(pagex, vol, currentVideo) {
      var volume = $(currentVideo[0]).parents('.ph-video').find('.ph-video__volume'),
          percentage = 0;

      /* If only volume have specificed
       then direct update volume */
      if (vol) {
        percentage = vol * 100;
      } else {
        var position = pagex - volume.offset().left;

        percentage = 100 * position / volume.width();
      }

      if (percentage > 100) {
        percentage = 100;
      }

      if (percentage < 0) {
        percentage = 0;
      }

      // Update volume bar and video volume
      $('.ph-video__volumebar').css('width', percentage + '%');
      currentVideo[0].volume = percentage / 100;

      // Change sound icon based on volume
      var $videoSound = $('.ph-video__sound');

      if (currentVideo[0].volume === 0 || currentVideo[0].volume <= 0.007) {
        $videoSound.removeClass('ph-video__sound2').addClass('ph-icon-volume-mute');
      } else if (currentVideo[0].volume > 0.5) {
        $videoSound.removeClass('ph-icon-volume-mute').addClass('ph-video__sound2');
      } else {
        $videoSound.removeClass('ph-icon-volume-mute').removeClass('ph-video__sound2');
      }
    },

    bindZoomLink: function() {
      var assetsArr = $('.ph-assest_listtext').val();

      $('#primary_image a#imageLink').on('click', function(e) {
        e.preventDefault();
      });

      if (typeof assetsArr !== 'undefined' && assetsArr.length === 1) {
        $('#carousel_alternate').hide();
      }


      $('.imageZoomLink').click(function() {
        if (!$('#primary_image a#imageLink img').hasClass('active')) {
          return;
        }

        $('.xl_image img').hide();

        var bstrone = '<div class="ph-col-12 left ph-mt-2"><div class="ph-setsiz scroller modal"><div id="thumbs" class="ph-setsiz"><ul id="carousel_modal" class="ph-setsiz1 ph-h-100 ph-w-100 jcarousel-skin modal alt galleriffic_slider thumbs noscript">';
        var bstrtwo = '</ul></div></div></div><div class="ph-imgsiz ph-imghtset xl_image ph-col-12 last">';


        $.colorbox({
          inline: true,
          href: '.zoom_lightbox',
          maxWidth: '90%',
          maxHeight: '780px',
          overlayClose: false,
          title: 'Enlarged view of picture'
        });
        $(document).on('cbox_complete', function() {
          $('#cboxLoadedContent').addClass('zoom_pop');

          var inx = $('#primary_image').attr('data-currentimage');

          if ($('.zoom_lightbox').html() === '') {
            var bstr = bstrone;

            for (var i = 1; i < assetsArr.length; i = i + 1) {
              if (assetsArr[i].indexOf('RTP') > -1 || assetsArr[i].lastIndexOf('/') > 15) {
                bstr = bstr + ('<li class="ph-w-100 ph-border-0 ph-col-6 ph-h-100 ph-p-0 ph-mr-1 ph-float-left"><span class="thumb ph-w-50 ph-border-0 ph-h-100 ph-m-0"><a href="#" class="noaction ph-pb-1"><img class="ph-w-100 ph-h-100" data-primaryimagesrc="' + assetsArr[i] + '"  src="' + assetsArr[i] + '?wid=96&hei=96&$jpglarge$"/></a></span></li>');
              }
            }

            bstr = bstr + bstrtwo;
            bstr = bstr + ('<img src="' + assetsArr[inx] + '?wid=510&hei=510&$jpglarge$"  id="xl_image_a" />');
            $('.zoom_lightbox').html(bstr);
            ACC.product.zoomImage();

            $('.zoom_lightbox #carousel_modal li a img').click(function() {
              $('#xl_image_a').attr('src', $(this).attr('data-primaryimagesrc') + '?wid=510&hei=510&$jpglarge$');
            });
          } else {
            $('#xl_image_a').attr('src', assetsArr[inx] + '?wid=510&hei=510&$jpglarge$');
          }

          $('.xl_image img').fadeIn();
          $.colorbox.resize();
          $('#cboxClose').click(function() {
            ACC.omniture.bindTrackConversion('interaction', 'view_image:close');
          });
        });
        $('.zoom_lightbox').eq(1).hide();

        $(document).on('cbox_close', function() {
          $('.zoom_lightbox').hide();
        });

        /* eslint-disable  consistent-return */
        return false;
      /* eslint-enable  consistent-return */
      });
    },

    domreadtFirstfunctions: function() {
      var $video = $('.ph-product__videoplay'),
          $videoVolume = $('.ph-video__volume'),
          $videoProgress = $('.ph-video__progress'),
          timeDrag = false,
          volumeDrag = false,
          videoClass = '.ph-video',
          productVideoplay = '.ph-product__videoplay';

      $video.on('loadedmetadata', function() {
        var currentVideo = $(this).parents('.ph-video').find(productVideoplay);

        // Set video properties
        $('.ph-video__currenttime').text(ACC.product.timeFormat(0));
        $('.ph-video__duration').text(ACC.product.timeFormat(currentVideo[0].duration));
        ACC.product.updateVolume(0, 0.7, currentVideo);
      });

      $videoVolume.on('mousedown', function(e) {
        var currentVideo = $(this).parents(videoClass).find(productVideoplay);

        volumeDrag = true;
        currentVideo[0].muted = false;
        $('.ph-video__sound').removeClass('ph-icon-volume-mute');
        ACC.product.updateVolume(e.pageX, null, currentVideo);
      });

      $videoVolume.on('mouseup', function(e) {
        if (volumeDrag) {
          var currentVideo = $(this).parents(videoClass).find(productVideoplay);

          volumeDrag = false;
          ACC.product.updateVolume(e.pageX, null, currentVideo);
        }
      });

      $videoVolume.on('mousemove', function(e) {
        if (volumeDrag) {
          var currentVideo = $(this).parents(videoClass).find(productVideoplay);

          ACC.product.updateVolume(e.pageX, null, currentVideo);
        }
      });

      $videoProgress.on('mousedown', function(e) {
        var currentVideo = $(this).parents(videoClass).find(productVideoplay);

        timeDrag = true;
        ACC.product.updatebar(e.pageX, currentVideo);
      });
      $videoProgress.on('mouseup', function(e) {
        if (timeDrag) {
          var currentVideo = $(this).parents(videoClass).find(productVideoplay);

          timeDrag = false;
          ACC.product.updatebar(e.pageX, currentVideo);
        }
      });
      $videoProgress.on('mousemove', function(e) {
        if (timeDrag) {
          var currentVideo = $(this).parents(videoClass).find(productVideoplay);

          ACC.product.updatebar(e.pageX, currentVideo);
        }
      });


      $video.on('timeupdate', function() {
        var currentVideo = $(this).parents('.ph-video').find(productVideoplay),
            currentPos = currentVideo[0].currentTime,
            maxduration = currentVideo[0].duration,
            perc = 100 * currentPos / maxduration;

        $(this).parents(videoClass).find('.ph-video__timebar').css('width', perc + '%');
        $(this).parents(videoClass).find('.ph-video__currenttime').text(ACC.product.timeFormat(currentPos));
      });

      if ($('.template-pages-product-productLayout2Page').length > 0) {
        ACC.product.bindZoomLink();
        ACC.product.productCarousalImage();
        ACC.product.carouselVideo();

        // Hiding Loader Gif
        setTimeout(function() {
          $('.hide-video-loader').hide();
        }, 2000);
      }
    },
    domreadtSecondfunctions: function() {
      var videoClass = '.ph-video',
          videoDesc = '.ph-video-desc',
          videoPlay = '.ph-product__videoplay';

      $('.ph-product__playIconDetailImage').on('click', function() {
        var currentVideo = $(this).parents(videoClass).find(videoPlay);

        ACC.product.playpause(currentVideo);
      });

      $(document).on('click', '.ph-pdpzoom', function() {
        var zoomElement = $(this).find('.ph-imageScreen').attr('data-zoom-image'),
            maxWid = '600px',
            maxHgth = '600px';

        if ($(window).width() < 450) {
          maxWid = '300px';
          maxHgth = '300px';
        }

        if ($(window).width() < 650) {
          maxWid = '400px';
          maxHgth = '400px';
        }

        $.colorbox({
          maxWidth: maxWid,
          maxHeight: maxHgth,
          width: '100%',
          height: '100%',
          scrolling: !1,
          html: '<div class="ph-zoomelement"><img class="ph-zoomimgmid" src="' + zoomElement + '"/></div>',
          close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
          onComplete: function() {
            $('.ph-zoomelement').zoom({
              on: 'click',
              onZoomIn: function() {
                $('.zoomImg').addClass('ph-zoom-image');
              },
              onZoomOut: function() {
                $('.zoomImg').removeClass('ph-zoom-image');
              }
            });
          }
        });
      });

      $('.ph-product__videoplay,.ph-video-desc').mouseenter(function() {
        $(this).parents(videoClass).find(videoDesc).show();
        $(this).parents(videoClass).find(videoIconSection).show();
      }).mousemove(function() {
        $(this).parents(videoClass).find(videoDesc).show();
        $(this).parents(videoClass).find(videoIconSection).show();
      }).mouseleave(function() {
        $(this).parents(videoClass).find(videoDesc).hide();
      });

      $('.ph-next-stage, .ph-prev-stage, .ph-product__carouselNavigation li').on('click', function() {
        $(videoPlay).find('video').each(function() {
          $(this)[0].pause();
          $(this)[0].muted = false;
          $(this).parents(videoClass).find('.ph-video__sound').removeClass('ph-icon-volume-mute');
          $(this).parents(videoClass).find('.ph-product__playIconDetailImage').removeClass('ph-icon-pause').addClass('ph-icon-play-button');

          ACC.product.updateVolume(0, 0.7, $(this));
        });
      });
    },
    requestingfullScreen: function($videoElement) {
      if ($videoElement[0].requestFullscreen) {
        $videoElement[0].requestFullscreen();
      } else if ($videoElement[0].webkitRequestFullscreen) {
        $videoElement[0].webkitRequestFullscreen();
      } else if ($videoElement[0].mozRequestFullScreen) {
        $videoElement[0].mozRequestFullScreen();
      } else if ($videoElement[0].msRequestFullscreen) {
        $videoElement[0].msRequestFullscreen();
      }
    },
    exitfullScreen: function() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },

    domreadtthirdfunctions: function() {
      $('.ph-switchscreen').on('click', function() {
        var agentId = (/iPad|iPhone|iPod/).test(navigator.userAgent) && !window.MSStream,
            $videoElement = $(this).parents('.ph-video').find('.ph-video-overlay'),
            videoClass = '.ph-video';

        if ($(this).hasClass('ph-icon-fullscreen')) {
          if (!agentId) {
            $videoElement.parents(videoClass).find('.ph-video__enlarge').children().removeClass('ph-icon-fullscreen').addClass('ph-icon-exit-fullscreen');
          }

          ACC.product.requestingfullScreen($videoElement);
        } else {
          if (agentId) {
            $videoElement.prop('controls', '');
          } else {
            $videoElement.parents(videoClass).find('.ph-video__enlarge').children().removeClass('ph-icon-exit-fullscreen').addClass('ph-icon-fullscreen');
          }

          ACC.product.exitfullScreen();

          $(videoIconSection).show();
        }
      });
    },
    checkForSpInCart: function() {
      var spProductInCart = $('.ph-spProductInCart').text(),
          spProdFlag = false;

      if (spProductInCart === 'false') {
        spProdFlag = true;
      }

      return spProdFlag;
    }
  };

  $(document).ready(function() {
    ACC.product.bindAll();
    ACC.product.domreadtFirstfunctions();
    ACC.product.domreadtSecondfunctions();
    ACC.product.domreadtthirdfunctions();
  });
  $(document).ready(function() {
    var timeout = null;

    if ($('.ph-final-price-pcms').length === 0 && $('.ph-final-price-hhs').length === 0) {
      $(addToCartButtonClass).show();
    }

    $(document).on('click', '.ph-sparepart_ack', function(e) {
      var addToCartClass = '.ph-addtocartform.add_to_cart_form',
          sparepartCheck = $(this).parents(addToCartClass).find('.ph-product-isSpProduct').attr('value');

      if (sparepartCheck === 'true' && ACC.product.checkForSpInCart()) {
        e.preventDefault();
        ACC.quickOrder.changeAcknowledgePopup($(this).parents(addToCartClass));
      }
    });

    $(document).on('click', '.ph-sparepart_ack_reorder', function() {
      var orderhistoryPanelHeading = '.ph-orderhistory_panel',
          orderhistoryTitle = '.ph-orderhistory_paneltitle .ph-orderhistory_title';

      if ($('.ph-isOneStore').text() === 'true') {
        orderhistoryTitle = '.ph-os-oh-panelTitle .ph-orderhistory_title';
      }

      if ($(this).parents(orderhistoryPanelHeading).find(orderhistoryTitle).attr('data-issparepartorder') === 'true' && ACC.product.checkForSpInCart()) {
        ACC.quickOrder.changeAcknowledgePopup($(this).parent());
      } else {
        $(this).parent().submit();
      }
    });

    $(document).on('mousemove', function() {
      if ($('.ph-icon-exit-fullscreen').length > 0) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          $('.ph-video-desc').hide();
          $(videoIconSection).hide();
        }, 5000);
      }
    });
    $(document).on('keydown', '.add_to_cart_form .qty', function(keyevent) {
      if (keyevent.keyCode === 13) {
        $(this).parents('form.add_to_cart_form')
          .find('.addtocartButton:visible,.ph-pdp_addtocart_button:visible,.ph-decisionpageconfigbutton,.ph-pdpconfigbutton').trigger('click');
        keyevent.preventDefault();
      }
    });
  });
})();
